'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _helpers = require('helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    UserProfileMenu: {
        displayName: 'UserProfileMenu'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/UserProfile/UserProfileMenu/UserProfileMenu.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var UserProfileMenu = _wrapComponent('UserProfileMenu')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        user: state.auth.user,
        lang: state.lang
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(UserProfileMenu, _Component);

    function UserProfileMenu() {
        (0, _classCallCheck3.default)(this, UserProfileMenu);
        return (0, _possibleConstructorReturn3.default)(this, (UserProfileMenu.__proto__ || (0, _getPrototypeOf2.default)(UserProfileMenu)).apply(this, arguments));
    }

    (0, _createClass3.default)(UserProfileMenu, [{
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('UserProfileMenu', null, { folderName: 'UserProfile/UserProfileMenu' }),
                _props = this.props,
                active = _props.active,
                user = _props.user,
                lang = _props.lang;


            return _react3.default.createElement(View, {
                active: active,
                user: user,
                lang: lang
            });
        }
    }]);
    return UserProfileMenu;
}(_react2.Component), _class2.propTypes = {
    active: _react2.PropTypes.string.isRequired,
    user: _react2.PropTypes.object,
    lang: _react2.PropTypes.object
}, _class2.defaultProps = {
    user: {}
}, _temp)) || _class));

exports.default = UserProfileMenu;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProfile/UserProfileMenu/UserProfileMenu.jsx
// module id = 1783
// module chunks = 0